import axios from "axios";

// export const baseUrl=`http://localhost:7012/`;
// export const baseUrl = `https://banglalink-d2g.rashigames.com/`;
export const baseUrl=`/`;

export const getGamesApi = async () => {
    const response = await axios.get(`${baseUrl}api/v1/get-games`);
    return response;
}

export const getProductListApi = async () => {
    const response = await axios.get(`${baseUrl}api/v1/product-list`);
    return response;
}

export const printLogsApi = async (data) => {
    const response = await axios.post(`${baseUrl}api/v1/print-logs`, data);
    return response;
}

export const sendOTPApi = async (data) => {
    const response = await axios.post(`${baseUrl}api/v1/send-otp`, data);
    return response;
}

export const verifyOTPApi = async (data) => {
    const response = await axios.post(`${baseUrl}api/v1/verify-otp`, data);
    return response;
}

export const checkSubscriptionApi = async (data) => {
    const response = await axios.post(`${baseUrl}api/v1/check-subscription`, data);
    return response;
}

export const deactivateApi = async (data) => {
    const response = await axios.post(`${baseUrl}api/v1/cancel-subscription`, data);
    return response;
}

export const subscriptionLogsApi = async (data) => {
    const response = await axios.post(`${baseUrl}api/v1/subscription-logs`, data);
    return response;
}

export const heApi = async () => {
    const response = await axios.get("http://ibadat.co/digi.msisdn.get.app");
    return response;
}